import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DeleteCard200,
  DeleteCard401,
  DeleteCard404,
  DeleteCardParams,
  GetCards200,
  GetCards401,
  RegisterCard200,
  RegisterCard400,
  RegisterCard401,
  RegisterCardBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 사용자가 등록한 카드 목록을 조회합니다.
등록된 모든 카드의 정보를 반환합니다.

 * @summary 카드 목록 조회
 */
export const getCards = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCards200>(
      {url: `/api/v1/payment-methods/cards`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCardsQueryKey = () => {
    return [`/api/v1/payment-methods/cards`] as const;
    }

    
export const getGetCardsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCards>>, TError = GetCards401>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCards>>> = ({ signal }) => getCards(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCardsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCards>>>
export type GetCardsInfiniteQueryError = GetCards401

/**
 * @summary 카드 목록 조회
 */
export const useGetCardsInfinite = <TData = Awaited<ReturnType<typeof getCards>>, TError = GetCards401>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCardsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCardsQueryOptions = <TData = Awaited<ReturnType<typeof getCards>>, TError = GetCards401>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCards>>> = ({ signal }) => getCards(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getCards>>>
export type GetCardsQueryError = GetCards401

/**
 * @summary 카드 목록 조회
 */
export const useGetCards = <TData = Awaited<ReturnType<typeof getCards>>, TError = GetCards401>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCardsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 결제용 카드를 등록합니다.
등록된 카드는 구독 결제에 사용됩니다.

 * @summary 카드 등록
 */
export const registerCard = (
    registerCardBody: RegisterCardBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RegisterCard200>(
      {url: `/api/v1/payment-methods/cards/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerCardBody
    },
      options);
    }
  


export const getRegisterCardMutationOptions = <TError = RegisterCard400 | RegisterCard401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCard>>, TError,{data: RegisterCardBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerCard>>, TError,{data: RegisterCardBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerCard>>, {data: RegisterCardBody}> = (props) => {
          const {data} = props ?? {};

          return  registerCard(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterCardMutationResult = NonNullable<Awaited<ReturnType<typeof registerCard>>>
    export type RegisterCardMutationBody = RegisterCardBody
    export type RegisterCardMutationError = RegisterCard400 | RegisterCard401

    /**
 * @summary 카드 등록
 */
export const useRegisterCard = <TError = RegisterCard400 | RegisterCard401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCard>>, TError,{data: RegisterCardBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerCard>>,
        TError,
        {data: RegisterCardBody},
        TContext
      > => {

      const mutationOptions = getRegisterCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 등록된 카드를 삭제합니다.
삭제된 카드는 더 이상 결제에 사용할 수 없습니다.

 * @summary 카드 삭제
 */
export const deleteCard = (
    cardId: string,
    params?: DeleteCardParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteCard200>(
      {url: `/api/v1/payment-methods/cards/${cardId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteCardMutationOptions = <TError = DeleteCard401 | DeleteCard404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: string;params?: DeleteCardParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: string;params?: DeleteCardParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCard>>, {cardId: string;params?: DeleteCardParams}> = (props) => {
          const {cardId,params} = props ?? {};

          return  deleteCard(cardId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCard>>>
    
    export type DeleteCardMutationError = DeleteCard401 | DeleteCard404

    /**
 * @summary 카드 삭제
 */
export const useDeleteCard = <TError = DeleteCard401 | DeleteCard404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: string;params?: DeleteCardParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCard>>,
        TError,
        {cardId: string;params?: DeleteCardParams},
        TContext
      > => {

      const mutationOptions = getDeleteCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    